<template>
  <div>
    <v-layout row wrap>
      <v-flex md3 pr-2>
        <v-flex md12 class="pr-2">
          <v-btn :class="{'elevation-5 mt-0':true, 'k-orange-linear white--text':selectedOption === 'due_dates', 'white':selectedOption !== 'due_dates'}" block large @click="selectedOption = 'due_dates'">
            Vencimientos
          </v-btn>
          <v-btn :class="{'elevation-5 mt-3':true, 'k-orange-linear white--text':selectedOption === 'tranches', 'white':selectedOption !== 'tranches'}" block large @click="selectedOption = 'tranches'">
            Tramos de mora
          </v-btn>
          <v-btn :class="{'elevation-5 mt-3':true, 'k-orange-linear white--text':selectedOption === 'portfolio_types', 'white':selectedOption !== 'portfolio_types'}" block large @click="selectedOption = 'portfolio_types'">
            Cartera
          </v-btn>
          <v-btn :class="{'elevation-5 mt-3':true, 'k-orange-linear white--text':selectedOption === 'account_types', 'white':selectedOption !== 'account_types'}" block large @click="selectedOption = 'account_types'">
            Tarjeta
          </v-btn>
        </v-flex>
      </v-flex>
      <v-flex md9 pl-2>
        <v-layout row wrap class="pa-3 white elevation-5">
          <v-flex md12 class="a-borders card-graphic" v-if="selectedOption === 'due_dates'">
            <v-layout row wrap>
              <v-flex md6 :class="{'pl-3 pb-2 f1-2em pt-2 k-orange-linear white--text':true}" v-for="(item, i) in headers.split(',')" :key="i">
                {{item}}
              </v-flex>
            </v-layout>
            <vue-perfect-scrollbar :settings="scrollbarSettings">
              <v-layout row wrap>
                <v-flex md12 class="data-table-list">
                  <template v-for="(item, i) in items">
                    <v-layout row wrap>
                      <v-flex md6 class="pl-3 pb-2 f1-2em pt-2">
                        {{selectedOption === 'due_dates' ? formatDate(item.label, 'YYYY-MM-DD', 'DD/MM/YYYY') : item.label}}
                      </v-flex>
                      <v-flex md6 class="pl-3 pb-2 f1-2em pt-2">
                        {{new Intl.NumberFormat('es-VE').format(item.total)}}
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-layout>
            </vue-perfect-scrollbar>
          </v-flex>
          <v-flex md12 v-if="this.selectedOption !== 'due_dates'">
            <v-card flat class="mr-10 pr-5">
              <div :id="`${selectedOption}-chart`" class="tables-tr-graph">
              </div>
            </v-card>
          </v-flex>
          <v-flex md12 v-else>
            <v-card flat>
              <div :id="`${selectedOption}-funnel`" class="tables-tr-graph">
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from 'vue';
import Chartist from 'chartist';
import tooltip from 'chartist-plugin-tooltips'; // eslint-disable-line
import dataTable from '@/components/global/DataTable';
import dueDateLists from '@/components/panel/DueDateList';
import legend from 'chartist-plugin-legend'; // eslint-disable-line
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';

Vue.component('dueDateLists', dueDateLists);

export default {
  components: {
    VuePerfectScrollbar,
    dataTable,
  },
  mounted() {
    this.getInfoOfChart();
    this.getInfoOfChart(null, 'metrics');
  },
  data() {
    return {
      dueDates: [],
      seriesChart: [],
      seriesLabels: [],
      seriesMonths: [],
      selectedOption: 'due_dates',
      filters: {
        status: '',
      },
      items: [],
      scrollbarSettings: {
        minScrollbarLength: 40,
        maxScrollbarLength: 320,
        wheelSpeed: 2,
      },
      headers: 'Fecha,Clientes',
    };
  },
  methods: {
    /* eslint-disable */
    lineChart() {
      new Chartist.Bar(`#${this.selectedOption}-funnel`, {
        labels: this.seriesLabels,
        series: [this.seriesChart],
      }, {
        height: '32vh',
        seriesBarDistance: 10,
        reverseData: true,
        horizontalBars: false,
        axisY: {
          offset: 40,
        },
        chartPadding: {
          right: 0,
        },
        labelInterpolationFnc: function(value) {
          return `${new Intl.NumberFormat('es-Ve').format(value)}`;
        },
        plugins: [
          Chartist.plugins.tooltip({
            transformTooltipTextFnc: (text) => {
              let tooltipText = `${new Intl.NumberFormat('es-VE').format(text)}`;
              return tooltipText;
            },
          }),
          Chartist.plugins.legend({
            className: 'inverse',
            legendNames: ['Vencimientos'],
          }),
        ],
      });
    },
    pieChart() {
      new Chartist.Pie(`#${this.selectedOption}-chart`, {
        series: this.seriesChart,
      }, {
        fullWidth: true,
        height: '24vh',
        donut: true,
        showLabel: false,
        donutWidth: 35,
        donutSolid: true,
        startAngle: 270,
        plugins: [
          Chartist.plugins.legend({
            className: 'inverse',
            legendNames: this.seriesLabels,
          }),
        ],
      });
    },
    getInfoOfChart(type) {
      this.axios.get(`/customers/${type || this.selectedOption}`).then((response) => {
        if (type === 'due_dates' || this.selectedOption === 'due_dates') {
          this.items = response.data;
          this.seriesChart = response.data.map(item => item.total);
          this.seriesLabels = response.data.map(item => moment(item.label, 'YYYY-MM-DD').format('DD/MM'));
        } else {
          this.items = response.data;
          this.seriesLabels = response.data.map(item => `${type === 'tranches' || this.selectedOption === 'tranches' ? 'Tramo ' : ''}${item.label} (${new Intl.NumberFormat('es-VE').format(item.total)})`);
          this.seriesChart = response.data.map(item => item.total);
        }
      });
    },
    formatDate(date, typeDate, toFormat) {
      return moment(date, typeDate).format(toFormat);
    },
    /* eslint-enable */
  },
  watch: {
    selectedOption(newVal) {
      if (newVal === 'due_dates') {
        this.headers = 'Fecha,Clientes';
      } else if (newVal === 'tranches') {
        this.headers = 'Tramo de mora,Clientes';
      } else if (newVal === 'portfolio_types') {
        this.headers = 'Cartera,Clientes';
      } else {
        this.headers = 'Tarjeta,Clientes';
      }
      this.getInfoOfChart(newVal);
    },
    seriesChart() {
      if (this.selectedOption === 'due_dates') {
        this.lineChart();
      } else {
        this.pieChart();
      }
    },
  },
};
</script>

<style scoped>
.negative-statuses-list {
  height: 35vh !important;
}

.data-table-list {
  height: 33vh !important;
}

.card-graphic {
  height: 39vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/panel/TablesTr.vue